import React, { Fragment } from "react";
import { Tag } from "antd";

interface Props {
  type?: string;
}

export default class DisplayTag extends React.Component<Props> {
  displayType(type: string): JSX.Element {
    let returnType = "";
    if (type === "mobile") {
      returnType = "Mob.";
    } else if (type === "fixed_line") {
      returnType = "Tel.";
    } else {
      returnType = type;
    }
    return <span>{<b>{`(${returnType})`}</b>} </span>;
  }

  displayTag(): JSX.Element {
    return (
      <Tag
        color="#87d068"
        style={{
          marginBottom: "2px",
        }}
      >
        Pri.
      </Tag>
    );
  }

  render(): JSX.Element {
    const { type } = this.props;
    return (
      <Fragment>{type ? this.displayType(type) : this.displayTag()}</Fragment>
    );
  }
}
